export default __webpack_public_path__ + "static/media/icon-onboarding.d74aed64.svg";